import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import List from './list.vue'
import Edit from './editor.vue'
import Layout from '../layout.vue'

const basePath = '/v-admin/interview-meeting-room/management'

export default {
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    titleI18nKey: 'admin.company.interviewMeetingRoomManagement.title.interviewMeetingRoomManagement',
    menu: {
      get label () {
        return i18n.t('admin.company.interviewMeetingRoomManagement.title.interviewMeetingRoomManagement')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,
      meta: {
        isNewPage: true,
        breadcrumb: { hidden: true },
        titleI18nKey: 'admin.company.interviewMeetingRoomManagement.title.interviewMeetingRoomManagement'
      }
    },
    {
      path: `${basePath}/add`,
      component: Edit,
      meta: {
        isNewPage: true,
        isEditMode: false,
        titleI18nKey: 'admin.company.interviewMeetingRoomManagement.title.addInterviewMeetingRoom'
      }
    },
    {
      path: `${basePath}/edit/:interviewMeetingRoomId`,
      component: Edit,
      meta: {
        isNewPage: true,
        isEditMode: true,
        titleI18nKey: 'admin.company.interviewMeetingRoomManagement.title.editInterviewMeetingRoom'
      }
    }
  ]
}
